import Box from '@mui/material/Box'
import CardActionArea, { cardActionAreaClasses } from '@mui/material/CardActionArea'
import React from 'react'

import Link from 'components/common/Link'
import { getWorkOrderDetailsPageUrl } from 'router/routes'

import WorkOrderContent from './WorkOrderContent'

type WorkOrderContentProps = React.ComponentProps<typeof WorkOrderContent>

type Props = {
  workOrderId: string
  cardStyles?: Record<string, unknown>
  contentProps: Omit<WorkOrderContentProps, 'onOpenActionMenu'>
  onOpenActionMenu?: WorkOrderContentProps['onOpenActionMenu']
}

const WorkOrderCardItem: React.FC<Props> = ({ workOrderId, cardStyles = {}, contentProps, onOpenActionMenu }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
      <CardActionArea
        to={getWorkOrderDetailsPageUrl(workOrderId)}
        component={Link}
        disableRipple
        disableTouchRipple
        sx={{
          [`& .${cardActionAreaClasses.focusVisible}, & .${cardActionAreaClasses.focusHighlight}`]: {
            display: 'none',
          },
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          width: '100%',
          px: 2,
          py: 1,
          ...cardStyles,
        }}
      >
        <WorkOrderContent {...contentProps} onOpenActionMenu={onOpenActionMenu} />
      </CardActionArea>
    </Box>
  )
}

export default WorkOrderCardItem
